import React from 'react'
import { useTranslation } from 'react-i18next'

export const BasketBoostSVGLarge: React.VFC<{
  fill?: string
  id: string
  className?: string
  title?: string
  desc?: string
}> = ({ className, title, desc, id }) => {
  const { t } = useTranslation(['svgs'])
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      id={id}
      className={className}
    >
      <title id={`${id}Title`}>{title || t('basket_alt')}</title>
      {desc && <desc id={`${id}Desc`}>{desc}</desc>}
      <path
        fill="white"
        transform="translate(0 21)"
        d="M0 0L7 0L7 2L0 2L0 0Z"
      />
      <path
        fill="white"
        transform="translate(3.67029 0.604004)"
        d="M10.05901 1.1688859L1.62286 12.881496L0 11.712596L8.4361095 0L10.05901 1.1688859Z"
        fillRule="evenodd"
      />
      <path
        fill="white"
        transform="translate(18.2704 0.60376)"
        d="M1.6209 0L9.8612003 11.40154L8.2403002 12.57304L0 1.17153L1.6209 0Z"
        fillRule="evenodd"
      />
      <path
        fill="white"
        transform="translate(1 8)"
        d="M0 0L30 0L30 6L0 6L0 0Z"
      />
      <path
        fill="white"
        transform="translate(2.91309 16)"
        d="M0 0L26.173611 0L25.312611 10.3322C25.139811 12.4054 23.40671 14 21.32641 14L4.8471899 14C2.76684 14 1.03378 12.4054 0.86101002 10.3322L0.75 9L4.0869098 9L4.0869098 7L0.58332998 7L0.41666001 5L12.08691 5L12.08691 3L0.25 3L0 0ZM8.0869102 9L6.07691 9L6.07691 7L8.0869102 7L8.0869102 9Z"
        fillRule="evenodd"
      />
    </svg>
  )
}
